type AppName = "client-view" | "crm" | "main";

const useAppLink = () => {
  const config = useRuntimeConfig();
  const { $env } = useNuxtApp();
  const baseUrl = $env.isDev ? "http://mydonut.local" : config.public.baseUrl;
  const { $i18n } = useNuxtApp();

  const getAppPort = (appName: AppName) => {
    if (!$env.isDev) {
      return "";
    }

    switch (appName) {
      case "client-view": {
        return ":3003";
      }

      case "crm": {
        return ":3002";
      }

      case "main": {
        return ":3001";
      }

      // No default
    }
  };

  const createAppLink = (link: string, appName: AppName, domain = "") => {
    const port = getAppPort(appName);

    if (domain) {
      // Если передан domain, разбиваем baseUrl на протокол и хост
      const [protocol, host] = baseUrl.split("://");

      return `${protocol}://${domain}.${host}${port}${link}`;
    }

    const locale = $i18n.locale.value;

    const localePattern = new RegExp(`^/(${$i18n.locales.value.map((l) => l.code).join("|")})/`);
    const hasLocale = localePattern.test(link);

    if (hasLocale) {
      return `${baseUrl}${port}${link}`;
    }
    return `${baseUrl}${port}/${locale}${link}`;
  };

  const createStorageLink = (link: string) => {
    return `${baseUrl}${link}`;
  };

  return {
    appHostname: new URL(baseUrl).hostname,
    createAppLink,
    createStorageLink,
  };
};

export { useAppLink };
